export const SET_USERS = "SET_USERS";

export const setUsers = (users: any) => {
    return { type: SET_USERS, value: users }
}


